<script lang="ts">
    import PostHero from '$lib/components/PostHero.svelte';
    import type { PostQuery } from '$gen/graphql';
    import MorePosts from '$lib/components/MorePosts.svelte';
    import { shuffle } from 'lodash-es';
    import ContentBlocks from './ContentBlocks.svelte';

    export let query: PostQuery;

    $: post = query?.entry?.__typename === 'posts_default_Entry' ? query.entry : null;
    $: morePosts = query ? [].concat(query.morePosts, query.moreExhibitions) : [];
</script>

<svelte:head>
    {#if post?.title}
        <title>{post.title}</title>
    {/if}
</svelte:head>

{#if post}
    <section style="grid-column: full;">
        {#each post?.keyImage as img}
            {#if img.__typename === 'assets_Asset'}
                <div class="md:aspect-video">
                    <figure class="bg-blue-500 flex h-full w-full flex-col md:flex-row  ">
                        <img
                            class="bg-red-500 h-[50vw] w-full object-cover md:h-full"
                            src={img.url}
                            srcset={img.srcset}
                            width={img.width}
                            height={img.height}
                            alt={img.description}
                            loading="lazy"
                        />
                        {#if img.description}
                            <figcaption class="md:writing-mode-bt text-center text-sm">
                                {#if img.description}
                                    {img.description}
                                {/if}
                            </figcaption>
                        {/if}
                    </figure>
                </div>
            {/if}
        {/each}

        <PostHero
            title={post.title}
            subTitle={post.subheading}
            topColor={post?.topColor[0]?.__typename === 'colors_Category'
                ? post.topColor[0].color
                : null}
            bottomColor={post?.bottomColor[0]?.__typename === 'colors_Category'
                ? post.bottomColor[0].color
                : null}
            projectInfo={post?.projectInfo}
        />
    </section>

    {#each post?.contentBlocks.slice(0, 1) as block (block.id)}
        <ContentBlocks {block} />
    {/each}
    {#if post?.subheading}
        <section class="px-0 text-2xl leading-6 lg:px-5">
            {post.subheading}
        </section>
    {/if}

    {#each post?.contentBlocks.slice(1) as block (block.id)}
        <ContentBlocks {block} />
    {/each}
{/if}

{#if query?.morePosts?.length > 0 || query?.morePosts}
    <MorePosts posts={shuffle(morePosts).slice(0, 3)} />
{/if}
